export default {
  "wt-textarea": "_wt-textarea_1nbt3sr_1",
  "wt-textarea__wrapper": "_wt-textarea__wrapper_1nbt3sr_5",
  "wt-textarea__inner": "_wt-textarea__inner_1nbt3sr_9",
  "wt-textarea_theme_light": "_wt-textarea_theme_light_1nbt3sr_51",
  "wt-textarea_theme_dark": "_wt-textarea_theme_dark_1nbt3sr_106",
  "wt-textarea_size_l": "_wt-textarea_size_l_1nbt3sr_162",
  "wt-textarea_size_m": "_wt-textarea_size_m_1nbt3sr_168",
  "wt-textarea_size_s": "_wt-textarea_size_s_1nbt3sr_174",
  "wt-textarea_size_xs": "_wt-textarea_size_xs_1nbt3sr_180",
  "wt-textarea_error": "_wt-textarea_error_1nbt3sr_186",
  "wt-textarea__icon": "_wt-textarea__icon_1nbt3sr_192",
  "wt-textarea_empty": "_wt-textarea_empty_1nbt3sr_224",
  "wt-textarea__error-message": "_wt-textarea__error-message_1nbt3sr_236",
  "wt-textarea__note": "_wt-textarea__note_1nbt3sr_242"
};